import { motion } from 'framer-motion';
import HomepageContact from '../components/Homepage/HomepageContact';
import HomepageGamesList from '../components/Homepage/HomepageGamesList';
import HomepageInfoButtons from '../components/Homepage/HomepageInfoButtons';
import HomepageInfoCard from '../components/Homepage/HomepageInfoCard';
import HomepageSlider from '../components/Homepage/HomepageSlider';
import HomepageTitle from '../components/Homepage/HomepageTitle';

const Homepage = () => (
  <motion.div
    key="TnCLobby"
    initial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    exit={{ opacity: 0 }}
    transition={{ duration: 0.5 }}
  >
    <div className="card">
      <HomepageTitle />
    </div>
    <div className="card">
      <HomepageInfoButtons />
    </div>
    <div className="card">
      <HomepageSlider />
    </div>
    <div className="card">
      <HomepageGamesList />
    </div>
    <div className="card">
      <HomepageInfoCard />
    </div>
    <div className="card">
      <HomepageContact />
    </div>
  </motion.div>
);

export default Homepage;
